import { clone } from '@/common/js/just.js'
import { AUDIENCES_TYPE } from '@/views/create/gdt/model/targeting-const.js'

/**
 * @description: 打开修改计划人群包弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onPopModify(rowIndex) {
  // 点击单行时设置check状态
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      return { ...row, populationCheck: index === rowIndex }
    })
  } else {
    if (!this.tableData.some((row) => row.populationCheck)) {
      return this.$Message.warning('请选择修改行')
    }
  }

  // 保存当前需要更改的行，如果是全选更改，那么保存第一个
  this.currentModifyTableRow = clone(this.tableData[rowIndex || 0])
  this.modal.showGlobalPopModify = true
}

/**
 * @description: 更换人群包确认
 * @return {*}
 */
export function onPopModifyConfirm(populations) {
  if (populations) {
    this.tableData = this.tableData.map((row) => {
      if (row.populationCheck) {
        const newRow = clone(row)
        newRow.target.populations = populations
        newRow.target.audienceType = AUDIENCES_TYPE.LIMITED
        return newRow
      }

      return row
    })
  }

  this.onModifyModalCancel()
}
